export const VERIFICATION_STATUS = {
  UN_VERIFIED: 'Unverified',
  AWAITING_VERIFICATION: 'AwaitingVerification',
  VERIFIED: 'Verified',
  REJECTED: 'Rejected',
};